export enum Move {
  ALeft = -1,
  ARight = 1,
  BLeft = 1,
  BRight = -1,
  Nothing = 0
}

export class SortUtils {
  private static getMovement(num: number): Move {
    if (num < 0) return Move.ALeft;
    if (num > 0) return Move.ARight;
    return Move.Nothing;
  }

  static nullsLast(a: any, b: any): Move {
    // nulls sort after anything else
    const aIsNull = a === null || a === undefined || a === '' || a === '--';
    const bIsNull = b === null || b === undefined || b === '' || b === '--';
    if (aIsNull && !bIsNull) return Move.ARight;
    if (bIsNull && !aIsNull) return Move.BRight;
    return Move.Nothing;
  }

  static compareNumerically = (a: string, b: string): Move => {
    return a?.trim()?.localeCompare('' + b?.trim(), 'en', { numeric: true });
  };

  static numberAscending = (a: number, b: number): Move => SortUtils.getMovement(a - b);
  static numberDescending = (a: number, b: number): Move => SortUtils.getMovement(b - a);

  // Sort nulls last is done on purpose here
  static numericStringAsc = (a: string, b: string): Move => {
    return SortUtils.nullsLast(a, b) || SortUtils.compareNumerically(a, b);
  };

  static numericStringDesc = (a: string, b: string): Move => {
    return SortUtils.nullsLast(a, b) || SortUtils.compareNumerically(b, a);
  };

  static numberAscNullsLast = (a: number, b: number): Move => {
    return SortUtils.nullsLast(a, b) || SortUtils.getMovement(a - b);
  };

  static numberDescNullsLast = (a: number, b: number): Move => {
    return SortUtils.nullsLast(a, b) || SortUtils.getMovement(b - a);
  };

  static dateAscNullsLast = (a: Date | null, b: Date | null): Move => {
    if (!!a && !!b) {
      const aTime = a?.getTime();
      const bTime = b?.getTime();
      return SortUtils.nullsLast(aTime, bTime) || SortUtils.getMovement((aTime ?? 0) - (bTime ?? 0));
    }
    return Move.Nothing;
  };

  static dateDescNullsLast = (a: Date | null, b: Date | null): Move => {
    if (!!a && !!b) {
      const aTime = a?.getTime();
      const bTime = b?.getTime();
      return SortUtils.nullsLast(aTime, bTime) || SortUtils.getMovement((bTime ?? 0) - (aTime ?? 0));
    }
    return Move.Nothing;
  };

  static byBooleanAsc = (a: boolean | null, b: boolean | null): Move => {
    if (a && !b) return Move.ALeft;
    if (b && !a) return Move.BLeft;
    return Move.Nothing;
  };

  static byBooleanDesc = (a: boolean | null, b: boolean | null): Move => {
    if (a && !b) return Move.BLeft;
    if (b && !a) return Move.ALeft;
    return Move.Nothing;
  };

  static bucketBy<T, K extends keyof any>(array: T[], keyFn: (item: T) => K): Record<K, T[]> {
    return array?.reduce((acc, item) => {
      const key = keyFn(item);
      if (!acc[key]) acc[key] = [];
      acc[key].push(item);
      return acc;
    }, {} as Record<K, T[]>);
  }
}
